import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Fleet", href: "#fleet" },
  { label: "Coverage", href: "#coverage" },
  { label: "Manifesto", href: "#manifesto" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="w-9 h-9 flex items-center justify-center border border-ice/40 bg-ice/5 group-hover:border-frost/60 transition-colors duration-300">
            <img src="/logo.svg" alt="ColdFast Couriers logo" data-testid="nav-logo-mark" className="w-5 h-5" />
          </span>
          <span className="font-display font-semibold tracking-tight text-lg uppercase">
            ColdFast
            <span className="text-ice text-xs font-mono font-normal tracking-[0.2em] ml-2 hidden sm:inline">
              SYDNEY
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10" data-testid="nav-links">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-mist hover:text-frost transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="#quote"
            data-testid="nav-quote-btn"
            className="hidden sm:inline-flex items-center gap-2 bg-blaze text-white font-mono text-xs uppercase tracking-[0.15em] px-6 py-3 hover:bg-frost hover:text-abyss transition-colors duration-300 active:scale-95"
          >
            Get a quote
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-snow p-2"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden bg-black/80 backdrop-blur-xl border-t border-white/10"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
                  className="font-display text-2xl uppercase tracking-tight text-snow hover:text-frost transition-colors duration-300"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#quote"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-quote-btn"
                className="inline-flex items-center justify-center gap-2 bg-blaze text-white font-mono text-xs uppercase tracking-[0.15em] px-6 py-4"
              >
                Get a quote
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
